// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__XxwwQ","colored":"Menu_colored__UZCe-"};